export default "__VITE_ASSET__BV_D3AWT__"